export const csroles = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];
